import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import shortid from 'shortid';
import SVG from 'react-inlinesvg';

const IconSVG = styled(SVG)`
  display: inline-block;
  height: ${props => props.height};
  width: ${props => props.width};

  svg {
    height: ${props => props.height};
    width: ${props => props.width};
    * {
      stroke-width: 3px;
      vector-effect: non-scaling-stroke;
      stroke-linejoin: miter;
      stroke-linecap: butt;
      stroke-miterlimit: 10;
      fill: none;
      stroke: url(#${props => props.fillid});
    }
  }
`;

class GradientIcon extends React.PureComponent {
  render() {
    const { fromColor, toColor, src, height, width } = this.props;
    const id = shortid.generate();

    return (
      <div className={this.props.className} data-swiftype-index="false">
        <svg
          style={{ width: 0, height: 0, position: 'absolute' }}
          aria-hidden="true"
          focusable="false"
        >
          <defs>
            <linearGradient id={id} x1="0%" y1="100%" x2="100%" y2="0%">
              <stop offset="0%" stopColor={fromColor} />
              <stop offset="100%" stopColor={toColor} />
            </linearGradient>
          </defs>
        </svg>
        <IconSVG src={src} height={height} width={width} fillid={id} />
      </div>
    );
  }
}

GradientIcon.propTypes = {
  fromColor: PropTypes.string,
  toColor: PropTypes.string,
  src: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};

GradientIcon.defaultProps = {
  fromColor: '#20d340',
  toColor: '#00d1ed',
  height: 'auto',
  width: '40px'
};

export default GradientIcon;
